<template>
    <div>
        <div class="text-center">
            <b-img :src="path + image" alt=""></b-img>
            <p class="text-22 text-muted semi-bold mt-2 mb-0">
                {{ title }}
            </p>
            <p class="text-22 semi-bold">
                {{ subtitle }}
            </p>
        </div>
        <hr />
        <b-card border-variant="primary" body-bg-variant="primary" class="mb-3">
            <p class="text-16 text-primary semi-bold mb-0 text-center">
                {{ $t('your_order_was_send') }}
            </p>
            <p class="text-16 text-primary semi-bold mb-0 text-center mt-1">
                <b-img class="service-clock mr-1 d-inline-block" :src="path + clock_image" alt="clock"></b-img> {{ $t('your_order_was_send_please_wait') }}
            </p>
        </b-card>
    </div>
</template>

<script>
import config from '../../../config'
import clock from '../../assets/old/clock.svg'

export default {
    data() {
        return {
            path: config.URL,
            clock_image: clock
        }
    },
    props: ['title', 'subtitle', 'image'],
}
</script>

<style></style>